import '@entrata/i18n'
// add translation keys to i18n store if we have them
i18nUtils.syncTranslations()
